import { Icon } from "../../../../../components";

export const StorefrontSupplierSellarCreditBanner = ({
  supplierName,
}: {
  supplierName: string;
}) => {
  return (
    <div className="flex items-center justify-center border-t border-b border-solid bg-zinc-50 px-3 py-1.5">
      <div className="inline-flex items-center gap-2">
        <p className={"text-sm font-medium text-zinc-800"}>
          Buy {supplierName} with
        </p>
        <p className="flex items-center gap-1 bg-linear-to-br from-[#B557F1] to-[#D213A6] bg-clip-text text-sm font-semibold text-nowrap text-transparent">
          <Icon
            icon="SELLAR_NEW"
            size={0.6669}
            color="#D213A6"
            className="shrink-0"
          />
          Sellar Credit
        </p>
      </div>
    </div>
  );
};
